/* src/app/components/customer-selector/customer-selector.component.scss */
#customerSelector .e-dlg-content {
  padding: 0px;
}
.e-dialog .e-dlg-content {
  padding: 0;
}
.e-footer-content {
  width: 100% !important;
  padding-right: 16px;
}
/*# sourceMappingURL=customer-selector.component.css.map */
